const firebaseConfig = {
    apiKey: "AIzaSyACYjnnZdy3LrSUA-JSpIZ3Y00g-_9Ou-E",
    authDomain: "hair-salon-app-a40ea.firebaseapp.com",
    projectId: "hair-salon-app-a40ea",
    storageBucket: "hair-salon-app-a40ea.appspot.com",
    messagingSenderId: "962215128217",
    appId: "1:962215128217:web:695f25e30d426fb4785c08"
  };
  export default firebaseConfig;